import { Attribute } from '../../decorators/attribute.decorator';
import { Component } from '../../decorators/component.decorator';
import { UIElement } from '../ui-element';
import stylesPlain from './ui-definition-list-item-plain.css';
import styles from './ui-definition-list.css';
import {
    UIDefinitionListLayout,
    UIDefinitionListLayouts,
} from './ui-definition-list.type';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIDefinitionList
 * @element ui-definition-list
 * @classdesc Represents a class for <code>ui-definition-list</code> element.
 * Serves as a list of label:value pairs. Replaces a need in text-only form fields.
 * Container for <code>ui-definition-list-item</code> elements (must be direct children).
 * @property {UIDefinitionListLayouts} [layout] {@attr layout} Layout of the definition list.
 * @property {boolean} [disableDivider=false] {@attr disable-divider} Whether the definition list items have dividers.
 * Only for layout="plain"
 * @example
 * <ui-definition-list>
 *   <ui-definition-list-item label="Color">Green</ui-definition-list-item>
 *   <ui-definition-list-item label="Size">Medium</ui-definition-list-item>
 * </ui-definition-list>
 */
@Component({
    tag: 'ui-definition-list',
    styles: [styles, stylesPlain],
})
export class UIDefinitionList extends UIElement {
    static readonly Layout: UIDefinitionListLayouts = {
        Plain: 'plain',
    };

    @Attribute(String) layout?: UIDefinitionListLayout;
    @Attribute(Boolean) disableDivider: boolean = false;

    /**
     * Sets listitem role for direct ui-definition-list-item children.
     * @private
     */
    private applyListItemRolesToChildren(): void {
        for (const child of this.children) {
            if (child.localName === 'ui-definition-list-item') {
                child.setAttribute('role', 'listitem');
            }
        }
    }

    /**
     * @inheritDoc
     */
    render(): void {
        this.updateElement({
            attributes: {
                role: 'list',
            },
        });
    }

    /**
     * @inheritDoc
     */
    hydrate(): void {
        this.applyListItemRolesToChildren();
    }
}
